import type { ProfileSummary } from "../shared/types";
import { homeForStation } from "../shared/origins";
import { stationLabel } from "./format";

/** Name the effective stop when a multi-destination profile has resolved to one. */
export function routeDestinationLabel(profile: ProfileSummary, destinationStationId: string): string {
	const destination = profile.destinations.find((station) => station.id === destinationStationId);
	return destination ? stationLabel(destination.name) : (profile.destinationLabel ?? profile.destinations.map((station) => stationLabel(station.name)).join(" / "));
}

/** Name the home paired with the effective return stop. */
export function routeHomeLabel(destinationStationId: string): string {
	return homeForStation(destinationStationId)?.label ?? "home";
}